import * as React from 'react';
import { List } from 'antd';
import { useAppSelector } from '../../../app/hooks';
import { fieldOperationType } from '../constants';
import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';
import { defaultBalanceFieldOperation } from '../utils';
import {RenderItem} from './OperationRenderItem';
import {selectNamedFields} from '../../named-fields/namedFieldsSlice';

interface Props {
  onChange: Function;
  balance: Balance;
  header: string;
};

export const BalanceNamedFieldOperations: React.FC<Props> = (props: Props) => {
  const allNamedFields = useAppSelector(selectNamedFields); // Loading of all namedFields should be done by a parent component
  const [localFields, setLocalFields] = React.useState<BalanceOperationBase[]|null>(null);

  const { onChange } = props;
  const operationFieldName: keyof Balance = 'balanceNamedFieldOperations';

  React.useEffect(() => {
    if (localFields === null && Array.isArray(props.balance[operationFieldName])) {
      if (props.balance[operationFieldName].length === 0 ) {
        setLocalFields([defaultBalanceFieldOperation(props.balance)]);
      } else {
        setLocalFields(sortBy(cloneDeep(props.balance[operationFieldName]), 'slug'));
      }
    }
  }, [props.balance, localFields]);

  // REMOVE
  const removeItem = React.useCallback((evt: React.MouseEvent<HTMLAnchorElement>, value:BalanceOperationBase) => {
    evt.preventDefault();
    if (localFields === null) { return; }
    const newValue = localFields.filter(item => item.id !== value.id);
    if (newValue.length === 0) {
      newValue.push(defaultBalanceFieldOperation(props.balance));
      // All local BalanceOperations are removed, set to null so useEffect will to new value from parent component
      onChange(operationFieldName, newValue);
      // Set LocalFields to null useEffect can pick up the change to props.balance
      return setLocalFields(null);
    }
    onChange(operationFieldName, newValue);
    return setLocalFields(newValue);
  }, [localFields, props.balance, onChange]);

  // CHANGE
  const localeOnChange = React.useCallback((balanceOperationBase:BalanceOperationBase, key:keyof BalanceOperationBase, value: string) => {
    if (localFields === null) { return; }
    setLocalFields(localFields.map(item => {
      if (item.id === balanceOperationBase.id) {
        item[key] = value;
      }
      return item;
    }));
    onChange(operationFieldName, localFields);
  }, [localFields, onChange]);

  // ADD
  const addItem = React.useCallback((evt: React.MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();
    if (localFields === null) { return; }
    setLocalFields([...localFields, defaultBalanceFieldOperation(props.balance)]);
  }, [localFields, props.balance]);

  if (localFields === null || allNamedFields === null) { return null; }

  return (
    <List
    header={props.header}
    dataSource={localFields}
    renderItem={(item, idx) => <RenderItem
      value={item}
      fieldOptions={allNamedFields}
      operationOptions={fieldOperationType}
      onRemove={removeItem}
      onAdd={addItem}
      onChange={localeOnChange}
      showAdd={idx === localFields.length -1}
      fieldPlaceholder="select-a-custom-field"
      />}
    />
  );
}

